// extracted by mini-css-extract-plugin
export var emptyState = "_4r-d";
export var statCard = "_4r-c";
export var table = "_4r-0";
export var tableCell = "_4r-4";
export var tableCellClickable = "_4r-5 _4r-4";
export var tableCellDefault = "_4r-6 _4r-4";
export var tableCellEmpty = "_4r-8";
export var tableCellWithValue = "_4r-7";
export var tableContainer = "_4r-e";
export var tableHeaderWeight = "_4r-1";
export var tableHeaderZone = "_4r-2";
export var tableRowHeader = "_4r-3";
export var viewModeButton = "_4r-9";
export var viewModeButtonActive = "_4r-a _4r-9";
export var viewModeButtonInactive = "_4r-b _4r-9";